<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
    <Nav></Nav>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-breadcrumb__inner"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name1 }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name2 }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="indexDetail index_center">
      <div class="indexDetail_title">
        <div class="indexDetail_title_text">{{ title }}</div>
      </div>
      <div class="indexDetail_title_date">
        <p>{{ updateTime }}</p>
      </div>
      <div class="indexDetail_title_source">
        <p>{{ source }}</p>
      </div>
      <div class="indexDetail_line"></div>
      <div class="indexDetail_content" v-html="newsContent"></div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import { getNewsInfoApi, getPlanInfoApi } from "@/api/index";

export default {
  components: { Foot, Nav },
  data() {
    return {
      id: "",
      newsContent: "",
      title: "",
      updateTime: "",
      type: "",
      name1: "",
      name2: "",
      source: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.type == 4) {
      this.getPlanInfo();
      this.name1 = "解决方案";
      this.name2 = "方案详情";
    } else {
      this.getNewsInfo();
      this.name1 = "企业动态";
      this.name2 = "动态详情";
    }
    this.$cookies.set("tabbar", this.type);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
  },
  methods: {
    //获取行业动态详情
    getNewsInfo() {
      var data = {
        id: this.id,
      };
      getNewsInfoApi(data).then((res) => {
        console.log(res);
        this.newsContent = res.data.content;
        this.title = res.data.title;
        this.updateTime = res.data.updateTime;
        this.source = res.data.source || "来源值null";
      });
    },
    //获取行业动态详情
    getPlanInfo() {
      var data = {
        id: this.id,
      };
      getPlanInfoApi(data).then((res) => {
        console.log(res);
        this.newsContent = res.data.content;
        this.title = res.data.title;
        this.updateTime = res.data.updateTime;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.index_center {
  width: 1200px;
  margin: 0 auto;
}

.indexDetail {
  margin-top: 70px;
  justify-content: space-between;
}

.indexDetail_title {
  display: flex;
  /*flex-direction: column;*/
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
}

.indexDetail_title_text {
  font-size: 30px;
  color: #333333;
}

.indexDetail_title_date {
  font-size: 16px;
  color: #999999;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 60px;
}

.indexDetail_title_date p {
  padding-left: 10px;
}
.indexDetail_title_source {
  display: flex;
  justify-content: flex-end;
  color: #999999;
  margin-bottom: 15px;
}

.indexDetail_line {
  border-bottom: 1px solid #000;
}

.indexDetail_content {
  padding-top: 37px;
  padding-bottom: 200px;
}

.breadcrumb_center {
  background-color: #f6f7f8;
  display: flex;
  /*width: 1200px;*/
  justify-content: space-around;
  height: 50px;
  margin: 0 auto;
}

.el-breadcrumb__inner {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}

.el-breadcrumb__inner img {
  padding: 0 20px 0px 0;
}

div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/detail.vue